import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Stack, Text } from '@chakra-ui/react';
import { useProfile, useWallets } from 'hooks';
import { useTranslation } from 'localization';

import { ExchangeWalletSelect } from 'components';

const Head: React.FC = () => {
  const { t } = useTranslation('component.deposit');
  const [searchparams, setSearchParams] = useSearchParams();

  const { data: wallets } = useWallets({ queries: {} });

  const { data: profile } = useProfile();

  const defaultWallet = profile?.country?.cca3 === 'IRQ' ? 'USD' : 'USDT';

  const onChangeWallet = ({ targetValue }: { targetValue?: string }) => {
    const list = wallets?.list ?? [];
    if (targetValue) {
      const w = list.find((wallet) => wallet.id === targetValue);
      if (w) {
        searchparams.set('wallet', w.id);
        searchparams.set('currency', w.currency.id);
      }
    } else {
      const fallback =
        list.find((item) => item.currency.symbol === defaultWallet) || list[0];
      if (fallback) {
        searchparams.set('wallet', fallback.id);
        searchparams.set('currency', fallback.currency.id);
      }
    }
    searchparams.set('tab', '0');
    setSearchParams(searchparams);
  };

  React.useEffect(() => {
    if (
      wallets &&
      wallets?.list?.length > 0 &&
      !searchparams.get('wallet') &&
      !searchparams.get('currency')
    ) {
      onChangeWallet({});
    }
  }, [wallets]);

  return (
    <Stack
      flexDir={{ base: 'column', md: 'row' }}
      align="center"
      justify={{ base: 'center', md: 'space-between' }}
      py={{ base: 2, md: 0 }}
      px={{ base: 4, lg: 0 }}
      gap={4}
      mt={{ base: 0, md: 4 }}
    >
      <Text fontSize="var(--chakra-font-sizes-4xl)" fontWeight="500">
        {t('deposit')}
      </Text>
      <Stack minW={{ base: '100%', md: '300px' }}>
        <ExchangeWalletSelect
          hideLabel
          label=""
          wallets={wallets?.list ?? []}
          value={searchparams.get('wallet') ?? ''}
          placeholder={t('selectWallet')}
          onChange={(id) => onChangeWallet({ targetValue: id })}
        />
      </Stack>
    </Stack>
  );
};

export default Head;
